import React from 'react';

import { EmptyContentText, ButtonLink } from './styles';

const EmptyRelatorios = ({ handleNovoRelatorio }) => {
  return (
    <EmptyContentText>
      Nenhum relatório gerado
      <span>
        Para gerar, clique no botão{' '}
        <ButtonLink
          type="button"
          onClick={handleNovoRelatorio}
          data-testid="link-add-contratante"
        >
          + novo relatório
        </ButtonLink>
      </span>
    </EmptyContentText>
  );
};

export default EmptyRelatorios;
